import {LocationApplication} from '@application/Site';
import {viewLocaleHandlerFunction, ViewLocaleView} from '@modules/locale/core/projection/viewLocale';

const viewLocaleView: ViewLocaleView = async () => {
  return await LocationApplication.getCompositeLocale();
};

export const viewLocaleHandler = viewLocaleHandlerFunction(viewLocaleView);
